export const CREW_MEMBER_DETAILS_TEXT = {
	loading: 'Loading…',
	loadFailed: 'Failed to load crew member.',
	crewListLabel: 'Crew List',
	tabsAriaLabel: 'Crew member details',
};
